<template>
	<div class="row">
		<div class="col-12">
			<div class="using-fb">
				<div class="hr-p" />
				<div class="text-us">
					<h3 class="text-center login-using-fb my-1">
						Or login with
					</h3>
				</div>
				<div class="hr-p" />
			</div>
		</div>
		<div class="col-md-8 m-auto">
			<button
				type="button"
				class="btn btn-login-facebook btn-block mt-4 mb-4"
				@click="processFacebookLogin"
			>
				<p class="d-inline align-middle">Facebook</p>
			</button>
		</div>
	</div>
</template>
<script>
import axios from "axios";
import LoginMessageBroker from "./LoginMessageBroker.vue";
export default {
	mixins: [LoginMessageBroker],

	props: {
		appId: {
			type: String,
			default: "",
		},
		scope: {
			type: String,
			default: "",
		},
		inFrame: {
			type: Boolean,
			default: false,
		},
		actionType: {
			type: String,
			default: "",
		},
	},

	data() {
		return {
			accesTokenFacebook: "",
			email: "",
			stateParam: "",
		};
	},

	methods: {
		submitFaceBookAccount() {
			var vm = this;
			axios
				.post(
					"/account/logon-provider",
					{
						ReturnUrl: "/",
						InFrame: this.inFrame,
						Provider: "facebook",
						Data: this.accesTokenFacebook,
					},
					{
						headers: {
							"Content-Type": "application/json",
						},
					}
				)
				.then(function (res) {
					if (res !== undefined && res.status === 200) {
						if (res.data === "new-connect")
							vm.$router.push({
								name: "connect",
								params: { accessToken: vm.accesTokenFacebook },
							});
						else
							vm.$_loginMessageBroker_notifySuccessfulLogin(
								vm.email
							);
					}
				})
				.catch(function (err) {
					console.log("Error connecting to facebook. " + err);
				});
		},

		processFacebookLogin() {
			var vm = this;
			vm.$store.commit('setTokenErrorMessage', { message: '', time: new Date() });
			vm.openFacebookLoginDialog(vm.stateParam, this.$store.state.redirectUrl);
		},
		openFacebookLoginDialog(stateGuid, redirectOauthUrl) {
			var vm = this;
			var popUpHeight = 600;
			var popUpwidth = 800;
			var screenLeft = 0,
				screenTop = 0;
			var windowWidth = 0,
				windowHeight = 0;
			var centerLeft = 0,
				centerTop = 0;

			if (typeof window.screenLeft !== "undefined") {
				screenLeft = window.screenLeft;
				screenTop = window.screenTop;
			} else if (typeof window.screenX !== "undefined") {
				screenLeft = window.screenX;
				screenTop = window.screenY;
			}

			windowWidth = window.screen.width;
			windowHeight = window.screen.height;

			if (window.navigator.userAgent.indexOf("MSIE") > -1) {
				centerLeft = screenLeft - w / 2;
				centerTop = screenTop - h / 2;
			} else if (window.navigator.userAgent.indexOf("Edge") > -1) {
				centerLeft = screenLeft - windowWidth;
				centerTop = screenTop - windowHeight;
			} else {
				centerLeft = screenLeft + windowWidth / 2 - popUpwidth / 2;
				screenTop + windowHeight / 2;
				centerTop = window.screen.height / 2 - popUpHeight / 2;
			}

			var view = window.open(
				"https://www.facebook.com/dialog/oauth?client_id=" +
					this.appId +
					"&redirect_uri=" +
					encodeURIComponent(redirectOauthUrl) +
					"&auth_type=rerequest" +
					"&scope=email" +
					"&state=" +
					stateGuid,
				"",
				"toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=no, copyhistory=no, width=" +
					popUpwidth +
					",height=" +
					popUpHeight +
					", top=" +
					centerTop +
					", left=" +
					centerLeft
			);
			window.addEventListener("message", vm.receivedAccessToken, false);
		},

		receivedAccessToken(event) {
			this.$gfLogger.logInfo('receivedAccessToken(), event: ', event);
			var vm = this;
			if (event.data && event.data.provider && event.data.provider === "facebook"
				&& event.data.data && event.data.data.hasOwnProperty('token')
			) {
				window.removeEventListener("message", vm.receivedAccessToken);
				if (event.data.data.error != null && event.data.data.error !== '') {
					vm.$store.commit('setTokenErrorMessage', { message: event.data.data.error, time: new Date() });
					vm.$store.commit('setAccessToken', '');
					vm.$store.commit('setAccountLinkMode', false);
					return;
				}
				else {
					vm.$store.commit('setTokenErrorMessage', { message: '', time: new Date() });
					vm.accesTokenFacebook = event.data.data.token;
					vm.submitFaceBookAccount();
				}
			}
		},
	},
	 mounted() {
		this.stateParam = btoa(window.location.origin);		
    },
};
</script>

<style scoped>
.btn-login-facebook {
	border-radius: 26px;
	color: #fff;
	background-color: #3b5997;
	font-weight: bold;
}
</style>